export default "__VITE_ASSET__ZXuzAhOi__"